import React from "react";
import CommonUtil from "../../utils/CommonUtil";
import GoogleAdsense from "./GoogleAdsense";
import KakaoAdfit from "./KakaoAdfit";

type PropsType = {
    googleAdsense?: {
        rootid: string;
        slot: string;
        responsiveYn?: "Y" | "N" // 반응형 여부 (Y/N) - 이게 'Y'면 'sideYn / height' props 값은 무시됨
        sideYn?: "Y" | "N"; // 사이드레일 여부 (Y/N)
        height?: number;
        align?: React.CSSProperties['textAlign'];
    };
    kakaoAdfit?: {
        rootid: string;
        unit: string;
        width: number;
        height: number;
        align?: React.CSSProperties['textAlign'];
    };
    marginStyle?: string;
    /** 리렌더/리마운트 트리거 전용 키(부모에서 URL 기반 등으로 관리) */
    refreshKey: string;
}

const AdView = ({ googleAdsense: adsense, kakaoAdfit: adfit, marginStyle, refreshKey }: PropsType) => {

    // 로컬 일 경우 광고 송출 안 되기도하고, 디버깅할 때 버벅거려서 숨김
    if (window.location.hostname === "localhost") return <></>;
    if (refreshKey === "") return <></>;
    else {
        if (adfit && !adsense) {
            return <KakaoAdfit {...adfit} marginStyle={marginStyle} refreshKey={refreshKey} />;
        }
        else if (!adfit && adsense) {
            return <GoogleAdsense {...adsense} marginStyle={marginStyle} refreshKey={refreshKey} />;
        }
        else if (adfit && adsense) {
            /*
            // 카카오 애드핏 수익률 & 노출률이 너무 떨어져서, 구글 애드센스 광고만 표시되도록 조치 함
            return <GoogleAdsense {...adsense} marginStyle={marginStyle} refreshKey={refreshKey} />;
            */
            if (CommonUtil.isMobileOs()) {
                return Math.round(Math.random()) === 0 ?
                    <KakaoAdfit {...adfit} marginStyle={marginStyle} refreshKey={refreshKey} />
                    : <GoogleAdsense {...adsense} marginStyle={marginStyle} refreshKey={refreshKey} />
                    ;
            }
            else {
                return <GoogleAdsense {...adsense} marginStyle={marginStyle} refreshKey={refreshKey} />;
            }
        }
        else {
            return <></>;
        }
    }
}

// routeKey 값이 안 바뀌면 리렌더 스킵
export default React.memo(AdView, (prev, next) => {
    return prev.refreshKey === next.refreshKey;
});